import constants from "../constants/index.json";

/**
 * Wraps the promise in a suspender for use with Suspense React
 * */
export function wrapPromise<T>(promise: Promise<T>) {
    let status = "pending";
    let response: T;

    const suspender = promise.then(
        (res) => {
            status = "success";
            response = res;
        },
        (err) => {
            status = "error";
            response = err;
        }
    );

    const read: () => T = () => {
        switch (status) {
            case "pending":
                throw suspender;
            case "error":
                throw response;
            default:
                return response;
        }
    };
    return { read };
}

/**
 * generic fetch call with return data type
 * */
export function request<TResponse>(url: string, config: RequestInit = {}) {
    return (
        fetch(`${constants.baseUrl}${url}`, config)
            // When got a response call a `json` method on it
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw response;
                }
            })
            // and return the result data.
            .then((data) => {
                return data as TResponse;
            })
    );
}

/**
 * generic fetch call with return data type
 * */
export function requestEmpty(url: string, config: RequestInit = {}) {
    return (
        fetch(`${constants.baseUrl}${url}`, config)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw response;
                }
            })
    );
}

export function fetchContent<T>(url: string): Promise<T> {
    const promise = request<T>(`${url}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    });

    return promise;
}

//export const zodFetch = async <TResponseSchema extends z.Schema>(
//  url: string,
//  responseSchema: TResponseSchema
//): Promise<z.infer<TResponseSchema>> => {
//  const response = await fetchContent<z.infer<TResponseSchema>>(url);

//  return responseSchema.parse(await response);
//};

/**
 * Posts content to the server and returns the results
 * @param url
 * @param data
 * @returns
 */
export function postNullContent<TRequest>(url: string, data: TRequest) {
    const promise = requestEmpty(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
    });

    return promise;
}

/**
 * Posts content to the server and returns the results
 * @param url
 * @param data
 * @returns
 */
export function postContent<TRequest, TResponse>(
    url: string,
    data: TRequest
): Promise<TResponse> {
    const promise = request<TResponse>(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
    });

    return promise;
}

/**
 * Posts content to the server and returns the results
 * @param url
 * @param data
 * @returns
 */
export function deleteContent<T>(url: string) {
    const promise = request<T>(url, {
        method: "DELETE",
    });

    return promise;
}
